import React from "react";
import { AddNewPetScreenWithBookingData } from "~/features/book-appointment/AddNewPetScreen";

const Component = () => {
  return <AddNewPetScreenWithBookingData />;
};

export default Component;
